<template>
    <div>
      <section class="reservation-intro">
        <h1>Réserver l'escale — Gîte d'en Lébé</h1>
        <p>
          L'escale est un charmant petit gîte pour 1 ou 2 personnes, situé au Gîte d'en Lébé à Touget dans le Gers.
          Confortable et climatisé, il est idéal pour découvrir la Gascogne en toute indépendance, que ce soit pour un week-end ou un séjour plus long.
        </p>
        <p>
          Consultez les disponibilités ci-dessous et réservez directement en ligne pour bénéficier du meilleur tarif.
          Pour en savoir plus sur cet hébergement, consultez la
          <router-link to="/nos-hebergements/studio">page de présentation de l'escale</router-link>.
        </p>
        <p>
          Retrouvez également nos
          <router-link to="/tarifs-et-reservation">tarifs et informations de réservation</router-link>
          ou <router-link to="/contact">contactez-nous</router-link> pour toute question.
        </p>
      </section>
      <div class="studio">
        <div class="gdf-WidgetBooking" data-source="owner" data-reference="H32G026830"></div>
      </div>
    </div>
</template>

<script>
export default {
    name: "reservationsStudio",
    data() {
        return {
            showReservation: true,
        };
    },

    mounted() {
      const script3 = document.createElement('script');
      script3.src = "https://widget.cloudspire.io/booking/sdk.js";
      script3.async = true;
      document.head.appendChild(script3);
    },

    beforeDestroy() {
      const script3 = document.querySelector('script[src="https://widget.cloudspire.io/booking/sdk.js"]');
      if (script3) {
        script3.remove();
      }
    },
};
</script>

<style scoped>
.reservation-intro {
  max-width: 900px;
  margin: 3rem auto 1rem;
  padding: 0 2rem;
  line-height: 1.6;
}

.reservation-intro h1 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.studio {
  margin: 5rem 11rem;
}

@media screen and (max-width: 450px) {
  .studio {
    margin: 0;
  }
}
</style>
